import { Stack, Typography, styled } from "@mui/material"
import { ChevronRight, ExternalLink } from "react-feather"

export const Container = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  color: theme.palette.primary.dark2,
}))

export const OuterContainer = styled(Container)(() => ({
  width: "100%",
}))

export const LabelsContainer = styled(Stack)(({ theme }) => ({
  flexDirection: "column",
  justifyContent: "start",
}))

export const TopLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: theme.typography.pxToRem(14),
}))

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(16),
  lineHeight: theme.typography.pxToRem(18),
  fontWeight: 600,
  whiteSpace: "nowrap",
}))

export const BottomLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.light1,
  fontSize: theme.typography.pxToRem(14),
  lineHeight: theme.typography.pxToRem(16),
  whiteSpace: "nowrap",
}))

export const Chevron = styled(ChevronRight)(({ theme }) => ({
  marginRight: "0px",
  transition: theme.transitions.create(["margin-right"]),
  width: theme.typography.pxToRem(18),
  color: theme.palette.primary.dark4,
}))
Chevron.defaultProps = {
  className: "icon",
}

export const confHoverChevron = {
  "&:hover .icon": {
    marginRight: "-5px!important",
  },
}

export const HoverExternalLink = styled(ExternalLink)(({ theme }) => ({
  width: theme.typography.pxToRem(18),
  color: theme.palette.primary.dark4,
  "& :where(polyline, line)": {
    transition: theme.transitions.create("transform"),
  },
}))
HoverExternalLink.defaultProps = {
  className: "arrow",
}

export const confHoverExternalLink = {
  "&:hover .arrow :where(polyline, line)": {
    transform: "translate(2px, -2px)",
  },
}
